import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { tweetsAPI } from '../api';
import { format, parseISO } from 'date-fns';
import { ja } from 'date-fns/locale';

export default function HistoryPage() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    (async () => {
      try {
        const res = await tweetsAPI.getHistory();
        setHistory(res.data);
      } catch {
        toast.error('履歴の取得に失敗しました');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const filtered = history.filter(h => filter === 'all' || h.status === filter);
  const successCount = history.filter(h => h.status === 'success').length;
  const failCount = history.filter(h => h.status === 'failed').length;

  return (
    <div>
      <div className="page-header">
        <div className="page-title">📊 投稿履歴</div>
        <div className="page-sub">過去の投稿ログ（最新100件）</div>
      </div>

      <div className="grid-3" style={{ marginBottom: 24 }}>
        <div className="stat-card">
          <div className="stat-value">{history.length}</div>
          <div className="stat-label">総投稿数</div>
        </div>
        <div className="stat-card">
          <div className="stat-value" style={{ color: 'var(--success)' }}>{successCount}</div>
          <div className="stat-label">成功</div>
        </div>
        <div className="stat-card">
          <div className="stat-value" style={{ color: 'var(--danger)' }}>{failCount}</div>
          <div className="stat-label">失敗</div>
        </div>
      </div>

      <div className="toolbar">
        <select className="select" style={{ width: 140 }} value={filter} onChange={e => setFilter(e.target.value)}>
          <option value="all">すべて</option>
          <option value="success">成功のみ</option>
          <option value="failed">失敗のみ</option>
        </select>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 60, color: 'var(--text-muted)' }}>読み込み中...</div>
      ) : filtered.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">📭</div>
          <div className="empty-state-text">投稿履歴がありません</div>
        </div>
      ) : (
        filtered.map(item => {
          let dateStr = item.posted_at;
          try { dateStr = format(parseISO(item.posted_at), 'yyyy年M月d日 HH:mm', { locale: ja }); } catch {}
          const isSuccess = item.status === 'success';
          return (
            <div key={item.id} className="tweet-card">
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <span className={`badge badge-${isSuccess ? 'posted' : 'failed'}`}>
                  {isSuccess ? '✅ 成功' : '❌ 失敗'}
                </span>
                <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{dateStr}</span>
                {item.tweet_x_id && (
                  <a
                    href={`https://x.com/i/web/status/${item.tweet_x_id}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{ fontSize: 12, color: 'var(--accent)', marginLeft: 'auto' }}
                  >
                    Xで見る →
                  </a>
                )}
              </div>
              <div className="tweet-card-content">{item.content}</div>
              {item.error_message && (
                <div style={{ marginTop: 8, fontSize: 12, color: 'var(--danger)', background: 'var(--danger-dim)', padding: '6px 10px', borderRadius: 6 }}>
                  {item.error_message}
                </div>
              )}
            </div>
          );
        })
      )}
    </div>
  );
}
